import { ErrorResponse } from "../responses/ErrorResponse";

export class UnauthorizedError extends ErrorResponse {
    public message: string;
}



// WEBPACK FOOTER //
// ./src/providers/api/errors/UnauthorizedError.ts